import { supabase } from '@/integrations/supabase/client';
import { CreateLocalShopPriceInput, LocalShopPrice, LocalShopPriceFilters } from '@/types/database/local-shop-prices';

export const localShopPriceService = {
  async getLocalShopPrices(filters?: LocalShopPriceFilters): Promise<LocalShopPrice[]> {
    let query = supabase
      .from('local_shop_prices')
      .select('*')
      .order('created_at', { ascending: false });

    if (filters?.product_name) {
      query = query.eq('product_name', filters.product_name);
    }
    if (filters?.location) {
      query = query.ilike('location', `%${filters.location}%`);
    }
    if (filters?.date_from) {
      query = query.gte('date', filters.date_from);
    }
    if (filters?.date_to) {
      query = query.lte('date', filters.date_to);
    }

    const { data, error } = await query.limit(10000);

    if (error) throw error;
    return data || [];
  },

  async createLocalShopPrice(price: CreateLocalShopPriceInput): Promise<LocalShopPrice> {
    const { data: { user } } = await supabase.auth.getUser();
    
    const { data, error } = await supabase
      .from('local_shop_prices')
      .insert({
        ...price,
        created_by: user?.id
      })
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async bulkCreateLocalShopPrices(prices: CreateLocalShopPriceInput[]): Promise<LocalShopPrice[]> {
    const { data: { user } } = await supabase.auth.getUser();
    
    const pricesWithUser = prices.map(price => ({
      ...price,
      created_by: user?.id
    }));

    const { data, error } = await supabase
      .from('local_shop_prices')
      .insert(pricesWithUser)
      .select();

    if (error) throw error;
    return data || [];
  },

  async updateLocalShopPrice(id: string, price: Partial<CreateLocalShopPriceInput>): Promise<LocalShopPrice> {
    const { data, error } = await supabase
      .from('local_shop_prices')
      .update(price)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async deleteLocalShopPrice(id: string): Promise<void> {
    const { error } = await supabase
      .from('local_shop_prices')
      .delete()
      .eq('id', id);

    if (error) throw error;
  }
};
